module.exports = __webpack_public_path__ + "static/media/A26.1280f1ea.png";